/**
 * compareState.js — включено ли сейчас сравнение двух исследований.
 *
 * Крошечный модуль ради одной вещи: избежать кольца зависимостей. Знать о
 * режиме сравнения нужно и разделу «Сравнение» (он его включает), и
 * uiManager (он не должен затирать чужие окна своей автоматикой). Если бы
 * они импортировали друг друга, получилось бы кольцо; общий сосед его
 * разрывает.
 *
 * Зачем вообще флаг. При смене раскладки changeLayout сам подгружает текущую
 * серию во ВСЕ окна — это правильное поведение для обычной работы: врач
 * переключился на «два окна» и не увидел чёрных прямоугольников. Но во время
 * сравнения оно затирает то, что врач только что положил в места 1 и 2.
 */

let _включено = false;
let _окна = [];

export const isCompareActive = () => _включено;

/** @param {boolean} v @param {string[]} [viewportIds] окна, занятые сравнением */
export function setCompareActive(v, viewportIds) {
  _включено = !!v;
  _окна = _включено && Array.isArray(viewportIds) ? [...viewportIds] : [];
}

/** Окна, которые сейчас заняты сравнением, — их автоматика не трогает. */
export const getCompareViewportIds = () => [..._окна];

// ── [10.8.0] Пара для совмещения ─────────────────────────────────────
//
// Совмещение раньше выбирало пару само: если нашлись КТ и МРТ — их, иначе два
// самых больших тома в кэше. Пока программа держала одно исследование,
// угадывать было почти не из чего. Теперь исследований два, серий в них бывает
// с десяток, и решать за врача нельзя: он сам положил в места 1 и 2 то, что
// хочет совместить.
//
// Пару кладёт сюда раздел «Сравнение», забирает — панель совмещения. Через
// общего соседа, чтобы модули не импортировали друг друга по кругу.
let _пара = null;

/**
 * @param {{fixedSeriesUID: string, movingSeriesUID: string,
 *          fixedIds: string[], movingIds: string[],
 *          fixedLabel?: string, movingLabel?: string} | null} p
 */
export function setComparePair(p) {
  _пара = (p && p.fixedIds?.length && p.movingIds?.length) ? { ...p } : null;
}

export const getComparePair = () => (_пара ? { ..._пара } : null);
